import AddPostButtonMobile from './AddPostButtonMobile.js';
import AddPostButtonWeb from './AddPostButtonWeb.js';
import {isSupportedDevice} from '../../shared/services';
import React, {PureComponent} from 'react';

class AddPostButtonContainer extends PureComponent {
  render() {
    return isSupportedDevice() ? <AddPostButtonMobile /> : <AddPostButtonWeb />;
  }
}

export default AddPostButtonContainer;



// WEBPACK FOOTER //
// ./app/features/newCommunityPost/components/AddPostButtonContainer.js